<script lang="ts">
	import BaseNode from './BaseNode.svelte';
	import { scenes } from 'src/stores/lists/scenes';
	import type { FlowNode, NodeData, NodeType } from '../types/flow-types';
	import { generateSceneActionLabel } from '../PropertyEditors/helpers/LabelGenerator';

	export let id: string;
	export let type: NodeType = 'sceneAction';
	export let data: NodeData;
	export let selected: boolean = false;
	export let validated: boolean = true;
	export let errors: string[] = [];

	$: isAlarm = type === 'alarmAction' || data.filterType === 'alarm';
	$: nodeType = isAlarm ? ('alarmAction' as const) : ('sceneAction' as const);
	$: icon = isAlarm ? 'fa-bell' : 'fa-play';
	$: displayText = (() => {
		$scenes;
		return generateSceneActionLabel({
			id,
			type: nodeType,
			position: { x: 0, y: 0 },
			data,
		} as FlowNode);
	})();
</script>

<BaseNode
	{id}
	type={nodeType}
	{data}
	{selected}
	{validated}
	{errors}
	hideOutputPort={true}
	cardTitle={String(displayText)}
	nodeTypeLabel={isAlarm ? 'Alarm action' : 'Scene action'}
	avatarOverride={{
		icon: `fa-solid ${icon}`,
		backgroundColor: isAlarm ? 'color-orange' : 'color-green',
	}}
	{...$$restProps}
/>
